"use client";

import { ThreeDMarquee } from "@/components/ui/three-d-marquee";
import { useContent } from "@/components/site/ContentProvider";
import { media } from "@/content/media";

/**
 * Work covers: THREE displace slider on `#container` (`.work_bg[data-src]`).
 * Case-4 visual is a full-viewport Aceternity 3D marquee sibling — not trapped
 * in the original narrow `.project` overlay (which only holds title/tags).
 * THREE plane 4 + thumb + bridge use `work_cover_4_bridge.webp` so CareLend→And
 * more runs the same displace morph as MKIT↔Kenaz; marquee soft-fades after.
 * Desktop covers everywhere — no `data-mobile-src` swap.
 */
export function WorkBackgrounds() {
  const site = useContent();
  return (
    <>
      <div
        className="work_bgs full_page work_mask"
        id="container"
        style={{ visibility: "hidden" }}
        aria-hidden="true"
      >
        {site.projects.map((project) => (
          <i
            className="work_bg work_aspect"
            data-src={"plane" in project ? project.plane : project.cover}
            key={project.id}
          />
        ))}
        <div className="overlay full_bg" />
      </div>
      {/* Temporary melt plate — layered between THREE and marquee. */}
      <div className="case4_bridge" aria-hidden="true">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src={media.projects["case-4"].bridge} alt="" draggable={false} />
      </div>
      <div className="work_marquee" aria-hidden="true">
        <ThreeDMarquee className="work_marquee_bg" images={site.projectsMore} />
        <div className="work_marquee_scrim" />
      </div>
    </>
  );
}
